import isEmail from 'validator/lib/isEmail';
export default class Validator {
    isPhone(str) {
        return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(str);
    }
    isEmail(str) {
        return str && isEmail(str);
    }
}
